import config from "./config";

export const sendExtensionLoginAction = async (tokenKey: string): Promise<void> => {
  await chrome.runtime.sendMessage(config.extensionID, { type: 'user/login', payload: tokenKey })
};
